export default "__VITE_ASSET__CKZTx8lW__"